import React from 'react';
import { View, TextInput } from 'react-native';
import getPlatformType from '../../helpers/getPlatform';

import { Typography, AmountBox, CurrencyBox, InputBox, RowContainer } from './style';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import { ODSInput } from '../../../openbrix-design-system/ui/atoms/ODSInput';
import { ODSIcon } from '../../../openbrix-design-system/ui/atoms/ODSIcon';

const RepaymentText = (props) => {

  const { colHeading, colValue, label, lColor, colHeading1, colValue1 } = props;
  const layoutType=getPlatformType();
  const { colors } = useTheme();

  return (
    <RowContainer style={{ marginTop: 12 }}>
      <View style={{ flexDirection: 'column', flex: 0.4, justifyContent: 'center' }}>
        {/* <Typography top={'20px'} align={'left'} color={lColor? lColor:'#000000'} size={'20px'} bold={lColor?800: 500}>
          {label}
        </Typography> */}
        <ODSText type='md-bold' color={lColor? lColor:colors.text.primary}>{label}</ODSText>
      </View>
      <View style={{ flexDirection: 'row', flex: 0.6, justifyContent: 'center' }}>
      { colValue1 || colValue1 == 0 ?
          <View style={{ flex: 0.5, paddingRight: 10 }}>
            {colHeading1? 
              <Typography style={{height:25}} bottom={layoutType=="phone"?'23px':'10px'} align={'left'} color={'#000000'} size={'16px'} bold={700}>
                {colHeading1}
              </Typography>
            : null}
             <ODSInput
            renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
            // label='Deposit Amount'
            editable={false}
            value={colValue1}
            />
            {/* <AmountBox>
              <CurrencyBox>
                <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                  £
                </Typography>
              </CurrencyBox>
              <InputBox>
                <TextInput
                  style={{ margin: 8, padding: 6, width: '96%', height: '100%', borderWidth: 0 }}
                  placeholder=""
                  keyboardType="numeric"
                  value={colValue1}
                  onChangeText={() => {}}
                />
              </InputBox>
            </AmountBox> */}
          </View>
        : null}

        <View style={{ flex: 0.5, paddingRight: 10 }}>
          {colHeading? (
            <Typography style={{height:25}} bottom={layoutType=="phone"?'23px':'10px'} align={'left'} color={'#000000'} size={'16px'} bold={700}>
              {colHeading}
            </Typography>
          ) : null}
          {/* <AmountBox>
            <CurrencyBox>
              <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                £
              </Typography>
            </CurrencyBox>
            <InputBox>
              <TextInput
                style={{ margin: 8, padding: 6, width: '96%', height: '100%', borderWidth: 0 }}
                placeholder=""
                keyboardType="numeric"
                value={colValue}
                onChangeText={() => {}}
              />
            </InputBox>
          </AmountBox> */}
          
            <ODSInput
            renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
            // label='Deposit Amount'
            editable={false}
            width={'100%'}
            value={colValue}
            />
        </View>
      </View>
    </RowContainer>
  );
};

export default RepaymentText;
